import type { ContentBlock } from "contracts/report/blocks";
import { For } from "solid-js";
import { BlockFields } from "./BlockFields";
import { BLOCK_TYPES, defaultBlock } from "./blockDefaults";

export { BlockViewer } from "./BlockViewer";

export function BlockEditor(props: {
  blocks: ContentBlock[];
  onChange: (blocks: ContentBlock[]) => void;
}) {
  const update = (index: number, block: ContentBlock) => {
    props.onChange(props.blocks.map((row, i) => (i === index ? block : row)));
  };
  const remove = (index: number) => {
    props.onChange(props.blocks.filter((_, i) => i !== index));
  };

  return (
    <div class="block-editor">
      <For each={props.blocks}>
        {(block, index) => (
          <div class="block-edit-row">
            <div class="block-edit-head">
              <select
                class="select"
                value={block.type}
                onChange={(event) =>
                  update(
                    index(),
                    defaultBlock(
                      event.currentTarget.value as ContentBlock["type"],
                    ),
                  )
                }
              >
                <For each={BLOCK_TYPES}>
                  {(type) => <option value={type.value}>{type.label}</option>}
                </For>
              </select>
              <button class="btn" type="button" onClick={() => remove(index())}>
                Remove
              </button>
            </div>
            <BlockFields
              block={block}
              onChange={(next) => update(index(), next)}
            />
          </div>
        )}
      </For>
      <button
        class="btn"
        type="button"
        onClick={() => props.onChange([...props.blocks, defaultBlock()])}
      >
        Add block
      </button>
    </div>
  );
}
